// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

body {
    font-family: 'Open Sans', sans-serif;
    font-size: 15px;
}

.form-group label {
    color: #818181;
}

.primary-color {
    color: #31b44c;
    /* color: var(--base-a-text-fg)!important; */
}

.primary-bg-color {
    background-color: #31b44c;
    /* background-color:var(--base-a-bg)!important; */
}

.primary-bg-color:hover,
.primary-bg-color:active {
    background-color: #2aa142;
}

.btn-outline-info{
    color: #2aa142;
    border-color: #2aa142;
}

.btn-outline-info:hover{
    color: #fff;
    background-color: #2aa142;
    border: 1px solid #2aa142;
}

.btn:first-child:active,
:not(.btn-check)+.btn:active{
    color: #fff;
    background-color: #2aa142;
    border: 1px solid #2aa142;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #fff;
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: #000;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.form-error {
    color: #ff0000;
}

.form-error input,
.form-error textarea,
.form-error select {
    color: #ff0000;
    border: 1px solid #ff0000;
}

.css-t3ipsp-control,
.css-1nmdiq5-menu{
    z-index: 99999999;
}
.css-13cymwt-control{
    z-index: 1;
}
.select-box .selected .select-multi div:last-child{
    z-index: 9;
}

.custom-chk {
    display: block;
    position: relative;
    margin-bottom: .3rem;
    cursor: pointer;
    font-size: .85rem;
    -webkit-user-select: none;
    user-select: none;
    font-weight: 400;
    text-align: left;
    padding-left: 25px;
}

.custom-chk input{
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}
.custom-chk .checkmark{
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #eee;
    border: 1px solid #52596d;
    border-radius: 4px;
    /*border: 1px solid #52596d;
    top: 50%;
    transform: translateY(-50%); */
}
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}
.custom-chk input:checked~.checkmark:after {
    display: block;
}
.custom-chk input:checked~.checkmark {
    border-color: #28479e;
}

.checkmark:after {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 12px;
    border: solid #5e5e5e;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
}

/* SERVICEPLACE */
.serviceplace-container-class .primary-color{
    color: #01aef0!important; 
}

.serviceplace-container-class .primary-bg-color {
    background-color: #01aef0!important;
}

.serviceplace-container-class input[type="file"]::-webkit-file-upload-button{
    background: #01aef0;
}

.serviceplace-container-class .primary-bg-color:hover,
.serviceplace-container-class .primary-bg-color:active,
.serviceplace-container-class input[type="file"]::-webkit-file-upload-button:hover {
    background-color: #009fdc!important;
}

.serviceplace-container-class .btn-outline-info{
    color: #009fdc;
    border-color: #009fdc;
}

.serviceplace-container-class .btn-outline-info:hover{
    background-color: #009fdc;
    border: 1px solid #009fdc;
}

.serviceplace-container-class .btn:first-child:active,
.serviceplace-container-class :not(.btn-check)+.btn:active{
    background-color: #009fdc;
    border: 1px solid #009fdc;
}

.serviceplace-container-class .feedback-form .normal-box .use-app .btn.active{
    background-color: #009fdc;
    color: #fff;
}

.serviceplace-container-class .rating-symbol .star {
    color: #009fdc;
}

.serviceplace-container-class .bookings .button-box span{
    color: #009fdc;
}

body:has(.serviceplace-container-class) .modal .modal-footer .primary-bg-color{
    background-color: #009fdc;
}

body:has(.serviceplace-container-class) .modal .modal-footer .primary-bg-color:hover{
    background-color: #009fdc;
}

body:has(.serviceplace-container-class) .modal .rating-symbol .star{
    color: #009fdc;
}

/* TELEHEALTH */
.telehealth-container-class .primary-color{
    color: #2aa142; 
}

.telehealth-container-class .primary-bg-color {
    background-color: #2aa142;
}

.telehealth-container-class input[type="file"]::-webkit-file-upload-button{
    background: #2aa142; 
}

.telehealth-container-class .primary-bg-color:hover,
.telehealth-container-class .primary-bg-color:active,
.telehealth-container-class input[type="file"]::-webkit-file-upload-button:hover {
    background-color: #2aa142;
}

.telehealth-container-class .btn-outline-info{
    color: #2aa142;
    border-color: #2aa142;
}

.telehealth-container-class .btn-outline-info:hover{
    background-color: #2aa142;
    border: 1px solid #2aa142;
}

.telehealth-container-class .btn:first-child:active,
.telehealth-container-class :not(.btn-check)+.btn:active{
    background-color: #2aa142;
    border: 1px solid #2aa142;
}

.telehealth-container-class .feedback-form .normal-box .use-app .btn.active{
    background-color: #2aa142;
    color: #fff;
}

.telehealth-container-class .rating-symbol .star {
    color: #2aa142;
}

.telehealth-container-class .bookings .button-box span{
    color: #2aa142;
}

.telehealth-container-class .health-chart a svg{
      fill: #2aa142;
}

.telehealth-container-class .tab-container button.active{
  background: #2aa142;
  color: #fff;
}

.telehealth-container-class .charts svg{
    fill: #2aa142;
}

body:has(.telehealth-container-class) .modal .modal-footer .primary-bg-color{
    background-color: #2aa142;
}

body:has(.telehealth-container-class) .modal .modal-footer .primary-bg-color:hover{
    background-color: #2aa142;
}

body:has(.telehealth-container-class) .modal .rating-symbol .star{
    color: #2aa142;
}



/* UKHRA */
.ukhra-container-class .primary-color,
.sevaapurulia-container-class .primary-color{
    color: #af1e25; 
}

.ukhra-container-class .primary-bg-color,
.sevaapurulia-container-class .primary-bg-color{
    background-color: #af1e25;
}

.ukhra-container-class input[type="file"]::-webkit-file-upload-button,
.sevaapurulia-container-class input[type="file"]::-webkit-file-upload-button{
    background: #af1e25;
}

.ukhra-container-class .primary-bg-color:hover,
.sevaapurulia-container-class .primary-bg-color:hover,
.ukhra-container-class .primary-bg-color:active,
.sevaapurulia-container-class .primary-bg-color:active
.ukhra-container-class input[type="file"]::-webkit-file-upload-button:hover,
.sevaapurulia-container-class input[type="file"]::-webkit-file-upload-button:hover{
    background-color: #952025;
}

.ukhra-container-class .btn-outline-info,
.sevaapurulia-container-class .btn-outline-info{
    color: #952025;
    border-color: #952025;
}

.ukhra-container-class .btn-outline-info:hover,
.sevaapurulia-container-class .btn-outline-info:hover{
    background-color: #952025;
    border: 1px solid #952025;
}

.ukhra-container-class .btn:first-child:active,
.ukhra-container-class :not(.btn-check)+.btn:active,
.sevaapurulia-container-class .btn:first-child:active,
.sevaapurulia-container-class :not(.btn-check)+.btn:active{
    background-color: #952025;
    border: 1px solid #952025;
}

.ukhra-container-class .feedback-form .normal-box .use-app .btn.active,
.sevaapurulia-container-class .feedback-form .normal-box .use-app .btn.active{
    background-color: #952025;
    color: #fff;
}

.ukhra-container-class .rating-symbol .star,
.sevaapurulia-container-class .rating-symbol .star{
    color: #af1e25;
}

.ukhra-container-class .bookings .button-box span,
.sevaapurulia-container-class .bookings .button-box span{
    color: #af1e25;
}

.ukhra-container-class .health-chart a svg,
.sevaapurulia-container-class .health-chart a svg{
    fill: #af1e25;
}

.ukhra-container-class .charts svg,
.sevaapurulia-container-class .charts svg{
    fill: #af1e25;
}

body:has(.ukhra-container-class) .modal .modal-footer .primary-bg-color,
body:has(.sevaapurulia-container-class) .modal .modal-footer .primary-bg-color
{
    background-color: #952025;
}

body:has(.ukhra-container-class) .modal .modal-footer .primary-bg-color:hover,
body:has(.sevaapurulia-container-class) .modal .modal-footer .primary-bg-color:hover{
    background-color: #952025;
}

body:has(.ukhra-container-class) .modal .rating-symbol .star,
body:has(.sevaapurulia-container-class) .modal .rating-symbol .star{
    color: #af1e25;
}
body:has(.sevaapurulia-container-class) .modal .primary-bg-color{
    background-color: #952025;
}

.sevaapurulia-container-class .tab-container button.active{
  background: #af1e25;
  color: #fff;
}

.ukhra-container-class .tab-container button.active {
    background: #af1e25;
    color: #fff;
}

/* RGVN */
.rgvn-container-class .primary-color,
.rajani-container-class .primary-color{
    color: #2aa142; 
}

.rgvn-container-class .primary-bg-color,
.rajani-container-class .primary-bg-color {
    background-color: #2aa142;
}

.rgvn-container-class input[type="file"]::-webkit-file-upload-button,
.rajani-container-class input[type="file"]::-webkit-file-upload-button{
    background: #2aa142;
}

.rgvn-container-class .primary-bg-color:hover,
.rgvn-container-class .primary-bg-color:active,
.rgvn-container-class input[type="file"]::-webkit-file-upload-button:hover,
.rajani-container-class .primary-bg-color:hover,
.rajani-container-class .primary-bg-color:active,
.rajani-container-class input[type="file"]::-webkit-file-upload-button:hover {
    background-color: #2aa142;
}

.rgvn-container-class .btn-outline-info,
.rajani-container-class .btn-outline-info{
    color: #2aa142;
    border-color: #2aa142;
}

.rgvn-container-class .btn-outline-info:hover,
.rajani-container-class .btn-outline-info:hover{
    background-color: #2aa142;
    border: 1px solid #2aa142;
}

.rgvn-container-class .btn:first-child:active,
.rgvn-container-class :not(.btn-check)+.btn:active,
.rajani-container-class .btn:first-child:active,
.rajani-container-class :not(.btn-check)+.btn:active{
    background-color: #2aa142;
    border: 1px solid #2aa142;
}

.rgvn-container-class .feedback-form .normal-box .use-app .btn.active,
.rajani-container-class .feedback-form .normal-box .use-app .btn.active{
    background-color: #2aa142;
    color: #fff;
}

.rgvn-container-class .rating-symbol .star,
.rajani-container-class .rating-symbol .star {
    color: #2aa142;
}

.rgvn-container-class .bookings .button-box span,
.rajani-container-class .bookings .button-box span{
    color: #2aa142;
}

.rgvn-container-class .tab-container button.active,
.rajani-container-class .tab-container button.active{
  background: #2aa142;
  color: #fff;
}

.rgvn-container-class .health-chart a svg,
.rajani-container-class .health-chart a svg{
    fill: #2aa142;
}

.rgvn-container-class .charts svg,
.rajani-container-class .charts svg{
    fill: #2aa142;
}

body:has(.rgvn-container-class) .modal .modal-footer .primary-bg-color,
body:has(.rajani-container-class) .modal .modal-footer .primary-bg-color{
    background-color: #2aa142;
}

body:has(.rgvn-container-class) .modal .modal-footer .primary-bg-color:hover,
body:has(.rajani-container-class) .modal .modal-footer .primary-bg-color:hover{
    background-color: #2aa142;
}

body:has(.rgvn-container-class) .modal .rating-symbol .star,
body:has(.rajani-container-class) .modal .rating-symbol .star{
    color: #2aa142;
}

.rgvn-container-class .tab-container button.active,
.rajani-container-class .tab-container button.active{
  background: #2aa142;
  color: #fff;
}

/* B2B */
.b2h-container-class .primary-color{
    color: #c10000; 
}

.b2h-container-class .primary-bg-color {
    background-color: #c10000;
}

.b2h-container-class input[type="file"]::-webkit-file-upload-button{
    background: #c10000;
}

.b2h-container-class .primary-bg-color:hover,
.b2h-container-class .primary-bg-color:active,
.b2h-container-class input[type="file"]::-webkit-file-upload-button:hover{
    background-color: #a30707;
}

.b2h-container-class .btn-outline-info{
    color: #a30707;
    border-color: #a30707;
}

.b2h-container-class .btn-outline-info:hover{
    background-color: #a30707;
    border: 1px solid #a30707;
}

.b2h-container-class .btn:first-child:active,
.b2h-container-class :not(.btn-check)+.btn:active{
    background-color: #a30707;
    border: 1px solid #a30707;
}

.b2h-container-class .feedback-form .normal-box .use-app .btn.active{
    background-color: #a30707;
    color: #fff;
}

.b2h-container-class .rating-symbol .star {
    color: #a30707;
}

.b2h-container-class .bookings .button-box span{
    color: #a30707;
}

.b2h-container-class .tab-container button.active{
  background: #a30707;
  color: #fff;
}

.b2h-container-class .charts svg{
    fill: #a30707;
}

body:has(.b2h-container-class) .modal .modal-footer .primary-bg-color{
    background-color: #a30707;
}

body:has(.b2h-container-class) .modal .modal-footer .primary-bg-color:hover{
    background-color: #a30707;
}

body:has(.b2h-container-clas) .modal .rating-symbol .star{
    color: #a30707;
}

.video-wrapper-a4 {
  aspect-ratio: 595 / 842; /* A4 portrait ratio */
  max-height: 80vh; /* Prevent overflow on small screens */
  margin: auto;
  overflow: hidden;
  position: relative;
  background: black;
}

.screenshot-a4 {
  max-height: 80vh; /* Prevent overflow on small screens */
  margin: auto;
  overflow: hidden;
  position: relative;
}

.screenshot-a4 img {
  width: 100%;
  height: 100%;
}

.video-wrapper-a4 video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-wrapper-a4.flip video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1); /* Optional: Flip front camera */
}

.camera-popup-modal.a4{
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.screenshot-counter-badge{
    float: left;
    width: 30px;
    height: 30px;
    text-align: center;
    background: red;
    color: white;
    font-weight: bold;
    border-radius: 50px;
    vertical-align: middle;
    font-size: large;
}
.camera-popup-modal .btn:hover{
    color: #000;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IAGzB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB;;kCAE8B;AAClC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IAGzB,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;MACM,aAAa;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;;;AAIA,UAAU;AACV;;IAEI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,SAAS;AACT;;IAEI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA,QAAQ;AACR;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,uBAAuB,EAAE,sBAAsB;EAC/C,gBAAgB,EAAE,sCAAsC;EACxD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB,EAAE,sCAAsC;EACxD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB,EAAE,gCAAgC;AACzD;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,WAAW;AACf","sourcesContent":[".App {\r\n    text-align: center;\r\n}\r\n\r\n.App-logo {\r\n    height: 40vmin;\r\n    pointer-events: none;\r\n}\r\n\r\nbody {\r\n    font-family: 'Open Sans', sans-serif;\r\n    font-size: 15px;\r\n}\r\n\r\n.form-group label {\r\n    color: #818181;\r\n}\r\n\r\n.primary-color {\r\n    color: #31b44c;\r\n    /* color: var(--base-a-text-fg)!important; */\r\n}\r\n\r\n.primary-bg-color {\r\n    background-color: #31b44c;\r\n    /* background-color:var(--base-a-bg)!important; */\r\n}\r\n\r\n.primary-bg-color:hover,\r\n.primary-bg-color:active {\r\n    background-color: #2aa142;\r\n}\r\n\r\n.btn-outline-info{\r\n    color: #2aa142;\r\n    border-color: #2aa142;\r\n}\r\n\r\n.btn-outline-info:hover{\r\n    color: #fff;\r\n    background-color: #2aa142;\r\n    border: 1px solid #2aa142;\r\n}\r\n\r\n.btn:first-child:active,\r\n:not(.btn-check)+.btn:active{\r\n    color: #fff;\r\n    background-color: #2aa142;\r\n    border: 1px solid #2aa142;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n    .App-logo {\r\n        animation: App-logo-spin infinite 20s linear;\r\n    }\r\n}\r\n\r\n.App-header {\r\n    background-color: #fff;\r\n    min-height: 80vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: calc(10px + 2vmin);\r\n    color: #000;\r\n}\r\n\r\n.App-link {\r\n    color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n.form-error {\r\n    color: #ff0000;\r\n}\r\n\r\n.form-error input,\r\n.form-error textarea,\r\n.form-error select {\r\n    color: #ff0000;\r\n    border: 1px solid #ff0000;\r\n}\r\n\r\n.css-t3ipsp-control,\r\n.css-1nmdiq5-menu{\r\n    z-index: 99999999;\r\n}\r\n.css-13cymwt-control{\r\n    z-index: 1;\r\n}\r\n.select-box .selected .select-multi div:last-child{\r\n    z-index: 9;\r\n}\r\n\r\n.custom-chk {\r\n    display: block;\r\n    position: relative;\r\n    margin-bottom: .3rem;\r\n    cursor: pointer;\r\n    font-size: .85rem;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    font-weight: 400;\r\n    text-align: left;\r\n    padding-left: 25px;\r\n}\r\n\r\n.custom-chk input{\r\n    position: absolute;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n    height: 0;\r\n    width: 0;\r\n}\r\n.custom-chk .checkmark{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 20px;\r\n    width: 20px;\r\n    background-color: #eee;\r\n    border: 1px solid #52596d;\r\n    border-radius: 4px;\r\n    /*border: 1px solid #52596d;\r\n    top: 50%;\r\n    transform: translateY(-50%); */\r\n}\r\n.checkmark:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    display: none;\r\n}\r\n.custom-chk input:checked~.checkmark:after {\r\n    display: block;\r\n}\r\n.custom-chk input:checked~.checkmark {\r\n    border-color: #28479e;\r\n}\r\n\r\n.checkmark:after {\r\n    left: 6px;\r\n    top: 2px;\r\n    width: 6px;\r\n    height: 12px;\r\n    border: solid #5e5e5e;\r\n    border-width: 0 3px 3px 0;\r\n    -webkit-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n}\r\n\r\n/* SERVICEPLACE */\r\n.serviceplace-container-class .primary-color{\r\n    color: #01aef0!important; \r\n}\r\n\r\n.serviceplace-container-class .primary-bg-color {\r\n    background-color: #01aef0!important;\r\n}\r\n\r\n.serviceplace-container-class input[type=\"file\"]::-webkit-file-upload-button{\r\n    background: #01aef0;\r\n}\r\n\r\n.serviceplace-container-class .primary-bg-color:hover,\r\n.serviceplace-container-class .primary-bg-color:active,\r\n.serviceplace-container-class input[type=\"file\"]::-webkit-file-upload-button:hover {\r\n    background-color: #009fdc!important;\r\n}\r\n\r\n.serviceplace-container-class .btn-outline-info{\r\n    color: #009fdc;\r\n    border-color: #009fdc;\r\n}\r\n\r\n.serviceplace-container-class .btn-outline-info:hover{\r\n    background-color: #009fdc;\r\n    border: 1px solid #009fdc;\r\n}\r\n\r\n.serviceplace-container-class .btn:first-child:active,\r\n.serviceplace-container-class :not(.btn-check)+.btn:active{\r\n    background-color: #009fdc;\r\n    border: 1px solid #009fdc;\r\n}\r\n\r\n.serviceplace-container-class .feedback-form .normal-box .use-app .btn.active{\r\n    background-color: #009fdc;\r\n    color: #fff;\r\n}\r\n\r\n.serviceplace-container-class .rating-symbol .star {\r\n    color: #009fdc;\r\n}\r\n\r\n.serviceplace-container-class .bookings .button-box span{\r\n    color: #009fdc;\r\n}\r\n\r\nbody:has(.serviceplace-container-class) .modal .modal-footer .primary-bg-color{\r\n    background-color: #009fdc;\r\n}\r\n\r\nbody:has(.serviceplace-container-class) .modal .modal-footer .primary-bg-color:hover{\r\n    background-color: #009fdc;\r\n}\r\n\r\nbody:has(.serviceplace-container-class) .modal .rating-symbol .star{\r\n    color: #009fdc;\r\n}\r\n\r\n/* TELEHEALTH */\r\n.telehealth-container-class .primary-color{\r\n    color: #2aa142; \r\n}\r\n\r\n.telehealth-container-class .primary-bg-color {\r\n    background-color: #2aa142;\r\n}\r\n\r\n.telehealth-container-class input[type=\"file\"]::-webkit-file-upload-button{\r\n    background: #2aa142; \r\n}\r\n\r\n.telehealth-container-class .primary-bg-color:hover,\r\n.telehealth-container-class .primary-bg-color:active,\r\n.telehealth-container-class input[type=\"file\"]::-webkit-file-upload-button:hover {\r\n    background-color: #2aa142;\r\n}\r\n\r\n.telehealth-container-class .btn-outline-info{\r\n    color: #2aa142;\r\n    border-color: #2aa142;\r\n}\r\n\r\n.telehealth-container-class .btn-outline-info:hover{\r\n    background-color: #2aa142;\r\n    border: 1px solid #2aa142;\r\n}\r\n\r\n.telehealth-container-class .btn:first-child:active,\r\n.telehealth-container-class :not(.btn-check)+.btn:active{\r\n    background-color: #2aa142;\r\n    border: 1px solid #2aa142;\r\n}\r\n\r\n.telehealth-container-class .feedback-form .normal-box .use-app .btn.active{\r\n    background-color: #2aa142;\r\n    color: #fff;\r\n}\r\n\r\n.telehealth-container-class .rating-symbol .star {\r\n    color: #2aa142;\r\n}\r\n\r\n.telehealth-container-class .bookings .button-box span{\r\n    color: #2aa142;\r\n}\r\n\r\n.telehealth-container-class .health-chart a svg{\r\n      fill: #2aa142;\r\n}\r\n\r\n.telehealth-container-class .tab-container button.active{\r\n  background: #2aa142;\r\n  color: #fff;\r\n}\r\n\r\n.telehealth-container-class .charts svg{\r\n    fill: #2aa142;\r\n}\r\n\r\nbody:has(.telehealth-container-class) .modal .modal-footer .primary-bg-color{\r\n    background-color: #2aa142;\r\n}\r\n\r\nbody:has(.telehealth-container-class) .modal .modal-footer .primary-bg-color:hover{\r\n    background-color: #2aa142;\r\n}\r\n\r\nbody:has(.telehealth-container-class) .modal .rating-symbol .star{\r\n    color: #2aa142;\r\n}\r\n\r\n\r\n\r\n/* UKHRA */\r\n.ukhra-container-class .primary-color,\r\n.sevaapurulia-container-class .primary-color{\r\n    color: #af1e25; \r\n}\r\n\r\n.ukhra-container-class .primary-bg-color,\r\n.sevaapurulia-container-class .primary-bg-color{\r\n    background-color: #af1e25;\r\n}\r\n\r\n.ukhra-container-class input[type=\"file\"]::-webkit-file-upload-button,\r\n.sevaapurulia-container-class input[type=\"file\"]::-webkit-file-upload-button{\r\n    background: #af1e25;\r\n}\r\n\r\n.ukhra-container-class .primary-bg-color:hover,\r\n.sevaapurulia-container-class .primary-bg-color:hover,\r\n.ukhra-container-class .primary-bg-color:active,\r\n.sevaapurulia-container-class .primary-bg-color:active\r\n.ukhra-container-class input[type=\"file\"]::-webkit-file-upload-button:hover,\r\n.sevaapurulia-container-class input[type=\"file\"]::-webkit-file-upload-button:hover{\r\n    background-color: #952025;\r\n}\r\n\r\n.ukhra-container-class .btn-outline-info,\r\n.sevaapurulia-container-class .btn-outline-info{\r\n    color: #952025;\r\n    border-color: #952025;\r\n}\r\n\r\n.ukhra-container-class .btn-outline-info:hover,\r\n.sevaapurulia-container-class .btn-outline-info:hover{\r\n    background-color: #952025;\r\n    border: 1px solid #952025;\r\n}\r\n\r\n.ukhra-container-class .btn:first-child:active,\r\n.ukhra-container-class :not(.btn-check)+.btn:active,\r\n.sevaapurulia-container-class .btn:first-child:active,\r\n.sevaapurulia-container-class :not(.btn-check)+.btn:active{\r\n    background-color: #952025;\r\n    border: 1px solid #952025;\r\n}\r\n\r\n.ukhra-container-class .feedback-form .normal-box .use-app .btn.active,\r\n.sevaapurulia-container-class .feedback-form .normal-box .use-app .btn.active{\r\n    background-color: #952025;\r\n    color: #fff;\r\n}\r\n\r\n.ukhra-container-class .rating-symbol .star,\r\n.sevaapurulia-container-class .rating-symbol .star{\r\n    color: #af1e25;\r\n}\r\n\r\n.ukhra-container-class .bookings .button-box span,\r\n.sevaapurulia-container-class .bookings .button-box span{\r\n    color: #af1e25;\r\n}\r\n\r\n.ukhra-container-class .health-chart a svg,\r\n.sevaapurulia-container-class .health-chart a svg{\r\n    fill: #af1e25;\r\n}\r\n\r\n.ukhra-container-class .charts svg,\r\n.sevaapurulia-container-class .charts svg{\r\n    fill: #af1e25;\r\n}\r\n\r\nbody:has(.ukhra-container-class) .modal .modal-footer .primary-bg-color,\r\nbody:has(.sevaapurulia-container-class) .modal .modal-footer .primary-bg-color\r\n{\r\n    background-color: #952025;\r\n}\r\n\r\nbody:has(.ukhra-container-class) .modal .modal-footer .primary-bg-color:hover,\r\nbody:has(.sevaapurulia-container-class) .modal .modal-footer .primary-bg-color:hover{\r\n    background-color: #952025;\r\n}\r\n\r\nbody:has(.ukhra-container-class) .modal .rating-symbol .star,\r\nbody:has(.sevaapurulia-container-class) .modal .rating-symbol .star{\r\n    color: #af1e25;\r\n}\r\nbody:has(.sevaapurulia-container-class) .modal .primary-bg-color{\r\n    background-color: #952025;\r\n}\r\n\r\n.sevaapurulia-container-class .tab-container button.active{\r\n  background: #af1e25;\r\n  color: #fff;\r\n}\r\n\r\n.ukhra-container-class .tab-container button.active {\r\n    background: #af1e25;\r\n    color: #fff;\r\n}\r\n\r\n/* RGVN */\r\n.rgvn-container-class .primary-color,\r\n.rajani-container-class .primary-color{\r\n    color: #2aa142; \r\n}\r\n\r\n.rgvn-container-class .primary-bg-color,\r\n.rajani-container-class .primary-bg-color {\r\n    background-color: #2aa142;\r\n}\r\n\r\n.rgvn-container-class input[type=\"file\"]::-webkit-file-upload-button,\r\n.rajani-container-class input[type=\"file\"]::-webkit-file-upload-button{\r\n    background: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .primary-bg-color:hover,\r\n.rgvn-container-class .primary-bg-color:active,\r\n.rgvn-container-class input[type=\"file\"]::-webkit-file-upload-button:hover,\r\n.rajani-container-class .primary-bg-color:hover,\r\n.rajani-container-class .primary-bg-color:active,\r\n.rajani-container-class input[type=\"file\"]::-webkit-file-upload-button:hover {\r\n    background-color: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .btn-outline-info,\r\n.rajani-container-class .btn-outline-info{\r\n    color: #2aa142;\r\n    border-color: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .btn-outline-info:hover,\r\n.rajani-container-class .btn-outline-info:hover{\r\n    background-color: #2aa142;\r\n    border: 1px solid #2aa142;\r\n}\r\n\r\n.rgvn-container-class .btn:first-child:active,\r\n.rgvn-container-class :not(.btn-check)+.btn:active,\r\n.rajani-container-class .btn:first-child:active,\r\n.rajani-container-class :not(.btn-check)+.btn:active{\r\n    background-color: #2aa142;\r\n    border: 1px solid #2aa142;\r\n}\r\n\r\n.rgvn-container-class .feedback-form .normal-box .use-app .btn.active,\r\n.rajani-container-class .feedback-form .normal-box .use-app .btn.active{\r\n    background-color: #2aa142;\r\n    color: #fff;\r\n}\r\n\r\n.rgvn-container-class .rating-symbol .star,\r\n.rajani-container-class .rating-symbol .star {\r\n    color: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .bookings .button-box span,\r\n.rajani-container-class .bookings .button-box span{\r\n    color: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .tab-container button.active,\r\n.rajani-container-class .tab-container button.active{\r\n  background: #2aa142;\r\n  color: #fff;\r\n}\r\n\r\n.rgvn-container-class .health-chart a svg,\r\n.rajani-container-class .health-chart a svg{\r\n    fill: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .charts svg,\r\n.rajani-container-class .charts svg{\r\n    fill: #2aa142;\r\n}\r\n\r\nbody:has(.rgvn-container-class) .modal .modal-footer .primary-bg-color,\r\nbody:has(.rajani-container-class) .modal .modal-footer .primary-bg-color{\r\n    background-color: #2aa142;\r\n}\r\n\r\nbody:has(.rgvn-container-class) .modal .modal-footer .primary-bg-color:hover,\r\nbody:has(.rajani-container-class) .modal .modal-footer .primary-bg-color:hover{\r\n    background-color: #2aa142;\r\n}\r\n\r\nbody:has(.rgvn-container-class) .modal .rating-symbol .star,\r\nbody:has(.rajani-container-class) .modal .rating-symbol .star{\r\n    color: #2aa142;\r\n}\r\n\r\n.rgvn-container-class .tab-container button.active,\r\n.rajani-container-class .tab-container button.active{\r\n  background: #2aa142;\r\n  color: #fff;\r\n}\r\n\r\n/* B2B */\r\n.b2h-container-class .primary-color{\r\n    color: #c10000; \r\n}\r\n\r\n.b2h-container-class .primary-bg-color {\r\n    background-color: #c10000;\r\n}\r\n\r\n.b2h-container-class input[type=\"file\"]::-webkit-file-upload-button{\r\n    background: #c10000;\r\n}\r\n\r\n.b2h-container-class .primary-bg-color:hover,\r\n.b2h-container-class .primary-bg-color:active,\r\n.b2h-container-class input[type=\"file\"]::-webkit-file-upload-button:hover{\r\n    background-color: #a30707;\r\n}\r\n\r\n.b2h-container-class .btn-outline-info{\r\n    color: #a30707;\r\n    border-color: #a30707;\r\n}\r\n\r\n.b2h-container-class .btn-outline-info:hover{\r\n    background-color: #a30707;\r\n    border: 1px solid #a30707;\r\n}\r\n\r\n.b2h-container-class .btn:first-child:active,\r\n.b2h-container-class :not(.btn-check)+.btn:active{\r\n    background-color: #a30707;\r\n    border: 1px solid #a30707;\r\n}\r\n\r\n.b2h-container-class .feedback-form .normal-box .use-app .btn.active{\r\n    background-color: #a30707;\r\n    color: #fff;\r\n}\r\n\r\n.b2h-container-class .rating-symbol .star {\r\n    color: #a30707;\r\n}\r\n\r\n.b2h-container-class .bookings .button-box span{\r\n    color: #a30707;\r\n}\r\n\r\n.b2h-container-class .tab-container button.active{\r\n  background: #a30707;\r\n  color: #fff;\r\n}\r\n\r\n.b2h-container-class .charts svg{\r\n    fill: #a30707;\r\n}\r\n\r\nbody:has(.b2h-container-class) .modal .modal-footer .primary-bg-color{\r\n    background-color: #a30707;\r\n}\r\n\r\nbody:has(.b2h-container-class) .modal .modal-footer .primary-bg-color:hover{\r\n    background-color: #a30707;\r\n}\r\n\r\nbody:has(.b2h-container-clas) .modal .rating-symbol .star{\r\n    color: #a30707;\r\n}\r\n\r\n.video-wrapper-a4 {\r\n  aspect-ratio: 595 / 842; /* A4 portrait ratio */\r\n  max-height: 80vh; /* Prevent overflow on small screens */\r\n  margin: auto;\r\n  overflow: hidden;\r\n  position: relative;\r\n  background: black;\r\n}\r\n\r\n.screenshot-a4 {\r\n  max-height: 80vh; /* Prevent overflow on small screens */\r\n  margin: auto;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.screenshot-a4 img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.video-wrapper-a4 video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.video-wrapper-a4.flip video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transform: scaleX(-1); /* Optional: Flip front camera */\r\n}\r\n\r\n.camera-popup-modal.a4{\r\n  position: fixed;\r\n  top: 0; left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.screenshot-counter-badge{\r\n    float: left;\r\n    width: 30px;\r\n    height: 30px;\r\n    text-align: center;\r\n    background: red;\r\n    color: white;\r\n    font-weight: bold;\r\n    border-radius: 50px;\r\n    vertical-align: middle;\r\n    font-size: large;\r\n}\r\n.camera-popup-modal .btn:hover{\r\n    color: #000;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
